import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

interface PostAdminButtonProps {
    onClick: () => void;
}

const PostAdminButton: React.FC<PostAdminButtonProps> = ({ onClick }) => {
    const location = useLocation();
    const role = localStorage.getItem('role');
    const disableButton = role === 'user' && location.pathname === '/admin/users';
    return (
        <button
            onClick={onClick}
            disabled={disableButton}
            className={`bg-brand-500 text-white p-4 rounded-full shadow-lg hover:bg-brand-600 transition-colors ${
                disableButton ? 'opacity-50 cursor-not-allowed hover:bg-brand-500' : ''
            }`}
        >
            <FaPlus />
        </button>
    );
};

export default PostAdminButton;
